import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from "./router";
import store from "./store";
import TrendChart from "vue-trend-chart";
import excel from 'vue-excel-export';
import VueDaumPostcode from "vue-daum-postcode";
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader

Vue.use(TrendChart);
Vue.use(VueLayers);
Vue.use(excel);
Vue.use(VueDaumPostcode);


Vue.config.productionTip = false;




new Vue({
  vuetify,
  router,
  store,      
  beforeCreate() {
    this.$store.dispatch("CheckLogin"); 
  },
  render: h => h(App)
}).$mount('#app')
